export default __webpack_public_path__ + "static/media/WCRO.f3a0668d.svg";